import { useEffect, useRef } from 'react';
import $ from 'jquery';
import { SiC, SiPython, SiJavascript, SiHtml5, SiMysql, SiGit, SiReact, SiPhp, SiLaravel, SiTypescript } from 'react-icons/si';
import { BsDiagram3 } from 'react-icons/bs';

const techSkills = [
  { name: 'HTML5 & CSS3', Icon: SiHtml5,         level: 85, color: '#e63946' },
  { name: 'JavaScript',   Icon: SiJavascript,    level: 80, color: '#ffd60a' },
  { name: 'React',        Icon: SiReact,         level: 65, color: '#61dafb' },
  { name: 'TypeScript',   Icon: SiTypescript,    level: 30, color: '#3178c6' },
  { name: 'PHP',          Icon: SiPhp,           level: 60, color: '#a78bfa' },
  { name: 'Laravel',      Icon: SiLaravel,       level: 25, color: '#ff2d20' },
  { name: 'C / C++',      Icon: SiC,             level: 80, color: '#00b4d8' },
  { name: 'Python',       Icon: SiPython,        level: 75, color: '#f4a261' },
  { name: 'SQL',          Icon: SiMysql,         level: 65, color: '#4ade80' },
  { name: 'Git & GitHub', Icon: SiGit,           level: 70, color: '#f77f00' },
  { name: 'UML',          Icon: BsDiagram3,      level: 60, color: '#9d4edd' },
];

const softSkills = [
  { name: 'Leadership',        level: 95 },
  { name: 'Team Work',         level: 95 },
  { name: 'Communication',     level: 82 },
  { name: 'Problem Solving',   level: 92 },
  { name: 'Adaptability',      level: 85 },
  { name: 'Time Management',   level: 80 },
  { name: 'Creativity',        level: 85 },
  { name: 'Critical Thinking', level: 90 },
];

export default function Skills() {
  const techRef = useRef(null);
  const softRef = useRef(null);

  useEffect(() => {
    // Tech cards: stagger entrance + animate progress bars on scroll (jQuery)
    const techObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        $(techRef.current).find('.sk-card').each(function (i) {
          const $card = $(this);
          setTimeout(() => {
            $card.addClass('sk-visible');
            $card.find('.sk-bar-fill').animate(
              { width: $card.find('.sk-bar-fill').data('level') + '%' },
              { duration: 900, easing: 'swing' }
            );
          }, i * 70);
        });
        techObserver.disconnect();
      });
    }, { threshold: 0.1 });

    if (techRef.current) techObserver.observe(techRef.current);

    // Soft skills: stagger + animate bars on scroll (jQuery)
    const softObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        $(softRef.current).find('.soft-row').each(function (i) {
          const $row = $(this);
          setTimeout(() => {
            $row.addClass('soft-row-visible');
            $row.find('.soft-bar-fill').animate(
              { width: $row.find('.soft-bar-fill').data('level') + '%' },
              { duration: 800, easing: 'swing' }
            );
          }, i * 80);
        });
        softObserver.disconnect();
      });
    }, { threshold: 0.1 });

    if (softRef.current) softObserver.observe(softRef.current);

    return () => { techObserver.disconnect(); softObserver.disconnect(); };
  }, []);

  return (
    <section id="skills" className="skills-section reveal">
      <h2 className="section-title">My <span>Skills</span></h2>
      <p className="section-sub">Technologies &amp; tools I work with</p>

      {/* ── Technical Skills ── */}
      <div ref={techRef} className="sk-grid">
        {techSkills.map((skill, i) => (
          <div
            key={i}
            className="sk-card"
            style={{ '--sk-color': skill.color }}
          >
            <div className="sk-top-bar" />
            <div className="sk-icon-wrap">
              <skill.Icon className="sk-icon" style={{ color: skill.color }} />
            </div>
            <h3 className="sk-name">{skill.name}</h3>
            <div className="sk-bar-track">
              <div
                className="sk-bar-fill"
                data-level={skill.level}
                style={{ width: 0, background: skill.color }}
              />
            </div>
            <span className="sk-pct" style={{ color: skill.color }}>{skill.level}%</span>
          </div>
        ))}
      </div>

      {/* ── Personal / Soft Skills ── */}
      <h3 className="soft-section-title">Personal Skills</h3>
      <div ref={softRef} className="soft-list">
        {softSkills.map((s, i) => (
          <div key={i} className="soft-row">
            <div className="soft-row-header">
              <span className="soft-row-name">{s.name}</span>
              <span className="soft-row-pct">{s.level}%</span>
            </div>
            <div className="soft-bar-track">
              <div
                className="soft-bar-fill"
                data-level={s.level}
                style={{ width: 0 }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
